<template>
  <div class="content-box">
    <div class="page-title">
      当前位置：首页 > 积分管理
    </div>
    <div class="content-info">
      <div class="content-info-title">积分管理</div>
      <div class="integral-all">
        <div class="flex-start integral-total">
          总积分：<span><b>{{ all }}</b>分</span>
          <!--          <a href="javascript:void 0">积分兑换</a>-->
        </div>
        <div class="integral-item-box">
          <div class="integral-item integral-item1">
            <span><b>{{ video }}</b>分</span>
            <!--            <a href="javascript:void  0">查看详情</a>-->
          </div>
          <div class="integral-item integral-item2">
            <span><b>{{ message }}</b>分</span>
            <!--            <a href="javascript:void  0">查看详情</a>-->
          </div>
          <div class="integral-item integral-item3">
            <span><b>{{ share }}</b>分</span>
            <!--            <a href="javascript:void  0">查看详情</a>-->
          </div>
          <div class="integral-item integral-item4">
            <span><b>{{ zan }}</b>分</span>
            <!--            <a href="javascript:void  0">查看详情</a>-->
          </div>
        </div>
      </div>

    </div>
    <div class="content-info">
      <div class="content-info-title">积分奖励</div>
      <div class="reward-box">
        <div class="reward-list">
          <div class="reward-item">
            <p><i class="iconfont iconjifen"></i>1000分以上</p>
            <img src="../../assets/img/integral-item5.jpg" alt="">
            <div class="text-box">获得电子参展证书</div>

            <el-button type="primary" @click="getImg">申请</el-button>

          </div>
          <div class="reward-item">
            <p><i class="iconfont iconjifen"></i>2000分以上</p>
            <img src="../../assets/img/integral-item6.jpg" alt="">
            <div class="text-box">获得北京社会组织孵化中心东部基地百人场地半天使用权</div>
            <el-button v-if="all<2000">积分未达到</el-button>
            <el-button type="primary" v-else><a href="http://yuyue.demo.csz.emof.cn/web/" target="_blank"
                                                style="color: #fff;">申请</a></el-button>
          </div>
          <div class="reward-item">
            <p><i class="iconfont iconjifen"></i>3000分以上</p>
            <img src="../../assets/img/integral-item7.png" alt="">
            <div class="text-box">获得一次今日头条、搜狐等网站推广内容的机会</div>
            <el-button v-if="all<3000">积分未达到</el-button>
            <el-button v-else-if="all>=3000 && means">已申请</el-button>
            <upFile :img-title="'fc'" @setImg="setImg" v-else></upFile>
          </div>
          <div class="reward-item">
            <p><i class="iconfont iconjifen"></i>5000分以上</p>
            <img src="../../assets/img/integral-item8.png" alt="">
            <div class="text-box">获得微店独立运权<br/>（自备域名，自己运维）</div>
            <el-button v-if="all<5000">积分未达到</el-button>
            <el-button type="primary" v-else @click="applyState">申请</el-button>
          </div>
        </div>
        <div class="mechanism">
          <h3>一、积分获取：</h3>
          <p>
            1、参加一次论坛直播100分，要求在线30分钟以上；<br/>
            2、获得一人留言80分，每个游客账户算一人；<br/>
            3、转发一次名片50分，每个游客账户算一次；<br/>
            4、为其他社会组织点赞一次得1分，每天不超过200分。<br/>
          </p>
          <br/>
          <br/>
          <h3>二、兑换机制：</h3>
          <p>
            汇展期间积分1000以上皆可获得电子参展证书；(积分达到后点击申请，即可下载电子参展证书)<br/>
            汇展期间积分2000分以上还可获得北京市社会组织孵化中心百人场地半天免费使用；(积分达到后点击申请，即可申请场地使用)<br/>
            汇展期间积分3000分以上还可获得一次今日头条、搜狐等网站推广内容的机会；(积分达到后点击申请，提交资料后会有相关人员联系您)<br/>
            汇展期间积分5000分以上还可获得微店独立运营权（自备域名，自己运维）;(积分达到后点击申请，即可修改机构信息)<br/>
            以上奖项可重复获得。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import upFile from "../../components/upFile3";

export default {
  name: "integral",
  components: {
    upFile
  },
  data() {

    return {
      all: 0,
      video: 0,
      message: 0,
      share: 0,
      zan: 0,
      means: '',
    }
  },
  created() {
    this.$emit('setIndex', 5)
    this.init()
  },
  methods: {

    init() {
      this.$api.apiContent.userIntegral({
        token: this.$store.state.user.token
      }).then(res => {
        this.all = res.data.all
        this.video = res.data.video
        this.message = res.data.message
        this.share = res.data.share
        this.zan = res.data.zan
        this.means = res.data.means
      })
    },
    getImg() {
      this.$api.apiContent.water({
        token: this.$store.state.user.token
      }).then(res => {
        let a = document.createElement("a")
        let event = new MouseEvent("click") // 创建一个单击事件
        a.href = 'http://cshadmin.demo.csz.emof.cn' + res.data
        a.download = "drcQrcode"
        a.target = "_blank"
        a.dispatchEvent(event); // 触发a的单击事件
      })
    },
    /*上传文件*/
    setImg(obj) {
      console.log(obj)
      this.$api.apiContent.wenjian({
        token: this.$store.state.user.token,
        file: obj.url
      }).then(() => {
        this.$message.success('提交成功')
        this.init()
      }).catch(e => {
        this.$message.error(e.msg)
      })
    },
    applyState(){
      this.$api.apiContent.applyState({
        token: this.$store.state.user.token
      }).then(() => {
        this.$message.success('申请成功，可点击机构信息进行修改')
      }).catch(e=>{
        this.$message.error(e.msg)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.content-info {
  display: flex;
  flex-direction: column;
  min-height: auto;
  margin-bottom: 30px;

  .content-info-title {
    display: flex;
    flex-direction: row;
    height: 56px;
    line-height: 56px;
    padding: 0 30px;
    border-bottom: 2px solid #f2f2f2;
    position: relative;
    justify-content: space-between;
    font-size: 18px;

    &:before {
      position: absolute;
      top: 17px;
      left: 15px;
      content: '';
      width: 6px;
      height: 22px;
      background-color: #f9aa0d;
    }
  }

  .integral-all {
    .integral-total {
      padding: 50px 40px 40px;
      font-size: 16px;
      line-height: 48px;

      span {
        color: #ffba00;

        b {
          font-size: 36px;
        }
      }
    }

    .integral-item-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 40px 40px;

      .integral-item {
        width: 22%;
        max-width: 343px;
        height: 120px;
        border-radius: 8px;
        position: relative;

        &.integral-item1 {
          background: url("../../assets/img/integral-item1.png") no-repeat top left;
        }

        &.integral-item2 {
          background: url("../../assets/img/integral-item2.png") no-repeat top left;
        }

        &.integral-item3 {
          background: url("../../assets/img/integral-item3.png") no-repeat top left;
        }

        &.integral-item4 {
          background: url("../../assets/img/integral-item4.png") no-repeat top left;
        }

        span {
          display: block;
          padding-top: 70px;
          padding-left: 35px;
          color: #fff;
          font-size: 18px;

          b {
            font-size: 24px;
          }
        }

        a {
          position: absolute;
          right: 10px;
          top: 30px;
          width: 78px;
          height: 34px;
          text-align: center;
          line-height: 32px;
          color: #fff;
          border-radius: 6px;
          border: solid 1px #ffffff;
        }
      }
    }
  }

  .reward-box {
    padding: 40px;

    .reward-list {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .reward-item {
        width: 23%;

        p {
          width: 100%;
          height: 44px;
          line-height: 42px;
          border: solid 1px #ffba00;
          text-align: center;
          color: #ffba00;
        }

        img {
          display: block;
          width: 100%;
          margin: 10px 0;
        }

        .text-box {
          display: flex;
          align-items: center;
          justify-content: space-around;
          width: 100%;
          height: 73px;
          padding: 10px;
          color: #fff;
          font-size: 18px;
          // line-height: 30px;
          text-align: center;
          background-color: #f9aa0d;
        }

        .el-button {
          display: block;
          width: 150px;
          height: 40px;
          line-height: 40px;
          margin: 10px auto;
          padding: 0;

          a {
            display: block;
            width: 150px;
            height: 40px;
            line-height: 40px;
          }
        }
      }
    }

    .mechanism {
      padding: 30px 0;

      h3 {
        font-size: 18px;
        line-height: 36px;
      }

      p {
        line-height: 28px;
        font-size: 16px;
      }
    }
  }
}
</style>
